import React from "react";
import NavLink from "../molecules/NavLink.jsx";
import styles from "./Navbar.module.css";

/**
 * ナビゲーションバー全体
 * @param {object} props
 * @param {Array<{href: string, label: string, onClick?: function}>} props.links - ナビゲーションリンクリスト
 * @param {string} [props.className] - 追加クラス
 */
const Navbar = ({ links, className = "" }) => (
  <nav className={`${styles.navbar} ${className}`.trim()}>
    {links.map(link => (
      <NavLink
        key={link.href}
        href={link.href}
        onClick={link.onClick}
      >
        {link.label}
      </NavLink>
    ))}
  </nav>
);

export default Navbar; 